<template>
  <v-container>
    <template v-if="loading">
      <div class="text-center">
        <v-progress-circular
          size="50"
          color="primary"
          indeterminate
        />
      </div>
    </template>

    <template v-else-if="order">
      <v-row
        v-if="!customer"
        align='center'
        justify='center'
      >
        <v-col cols='12' sm='8'>
          <CustomerForm :order="order"/>
        </v-col>
      </v-row>

      <v-row
        v-for='reservation in order.reservations'
        :key='reservation.id'
        align='center'
        justify='center'
      >
        <v-col cols='12' sm='8'>
          <ReservationCardPublic
            :order="order"
            :reservation="reservation"
          />
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <v-card elevation="1" class="pa-3">
        <h4 class="d-flex justify-center subtitle">
          {{ $t('alerts.order_to_redeem_not_available') }}
        </h4>
        <br/>
        <div class="text-center">
          <v-btn
            x-large
            color='success'
            class='mr-2 mb-2'
            :to='{name: "dashboard"}'
          >
            {{ $t('sidebar.dashboard') }}
          </v-btn>
        </div>
      </v-card>
    </template>
  </v-container>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { orderMixin } from '../../../mixins/order_mixin'
  import { orderCustomerMixin } from '../../../mixins/order_customer_mixin'
  import ReservationCardPublic from '../../reservations/reservation_card_public'
  import AuthenticationButtons from '../../session/authentication_buttons'
  import CustomerForm from '../customer/customer_form'

  export default {
    name: 'OrderPublic',
    components: {
      CustomerForm,
      ReservationCardPublic,
      AuthenticationButtons
    },
    mixins: [
      orderMixin,
      orderCustomerMixin,
    ],
    created() {
      this.$store.dispatch('order/fetchOrderPublic', this.$route.params.uuid)
        .then(order => {
          if (this.$route.query.confirmation) {
            this.$store.dispatch('layout/addAlert', {
              type: 'success',
              key: 'email_verified'
            })
          }
        }).catch(error => {
          this.$router.push({ name: 'dashboard' })
          this.$store.dispatch('layout/addAlert', {
            type: 'warning',
            key: 'order_to_redeem_not_available'
          })
      })
    },
    computed: {
      ...mapState('layout', ['loading', 'submitting']),
      ...mapGetters('session', ['isLoggedIn'])
    }
  }
</script>
